import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  standalone: true,
  name: 'programaNome'
})
export class ProgramaNomePipe implements PipeTransform {

  transform(value: string): string {
    return value
      .replace('(', '<br/>(')
  }

}
